import MainSection from '../../components/mainPage/main_section';
import SchoolsSection from '../../components/mainPage/schools_section';
import BulletinsSection from '../../components/mainPage/bulletins_section';
import FooterSection from '../../components/mainPage/footer_section';
import About from '../../components/mainPage/about';
import YearConference from '../../components/mainPage/year_conference';

const Main = () => {
    return (
        <>
            <div className="content section">
                <MainSection />
            </div>
            <div className="content section" id="about">
                <About />
            </div>
            <div className="content section" id="schools">
                <SchoolsSection />
            </div>
            <div className="content section" id="yearly_conference">
                <YearConference />
            </div>
            <div className="content section" id="bulletins">
                <BulletinsSection />
            </div>
            <div className="content section" id="contacts">
                <FooterSection />
            </div>
        </>
    );
}

export default Main;